import { ATRIBUTOS, type Pontos } from './escala'

/**
 * xorshift32: pequeno, determinístico, sem dependência.
 *
 * Não é aleatoriedade de partida — a física continua sem sorteio. É só o que
 * faz dois Epic Efeito serem parecidos em vez de idênticos, e precisa dar o
 * MESMO resultado em qualquer máquina, para sempre. Seed zero é tratada por
 * quem chama: o xorshift não sai do zero.
 */
export function xorshift32(seed: number): () => number {
  let x = seed >>> 0 || 0x9e3779b9
  return () => {
    x ^= x << 13; x >>>= 0
    x ^= x >>> 17
    x ^= x << 5; x >>>= 0
    return x
  }
}

/**
 * Move até `amplitude` pontos entre atributos, um por vez.
 *
 * Cada passo tira 1 de um atributo e põe 1 em outro, só entre os que o
 * arquétipo pontua (peso > 0) — o padrão não ganha quebra por sorteio — e só
 * se couber (origem > 0, destino < 100). A soma não muda por construção, e
 * nenhum atributo se afasta mais que `amplitude` do valor base.
 */
export function variarComSeed(pontos: Pontos, pesos: Pontos, seed: number, amplitude: number): Pontos {
  if (seed === 0 || amplitude <= 0) return { ...pontos }
  const proximo = xorshift32(seed)
  const eixos = ATRIBUTOS.filter((k) => pesos[k] > 0)
  if (eixos.length < 2) return { ...pontos }

  const fora = { ...pontos }
  for (let passo = 0; passo < amplitude; passo++) {
    const de = eixos[proximo() % eixos.length]!
    const para = eixos[proximo() % eixos.length]!
    if (de === para) continue
    if (fora[de] - 1 < pontos[de] - amplitude || fora[para] + 1 > pontos[para] + amplitude) continue
    if (fora[de] <= 0 || fora[para] >= 100) continue
    fora[de] -= 1
    fora[para] += 1
  }
  return fora
}
